import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PhConfigLoaderService } from '@common/ph-config-loader';
import { CustomerSelectorService } from './customer-selector.service';

export interface CmptData {
  customers: CmptDataCustomer[];
}

export interface CmptDataCustomer {
  id: number;
  name: string;
  alias: string;
  subdomain: string;
  crm_account_id: string;
  crm_site_id: string;
  crmData: string;
}

@Component({
    selector: 'ca-customer-selector',
    templateUrl: './customer-selector.component.html',
    styleUrls: ['./customer-selector.component.scss'],
    providers: [CustomerSelectorService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomerSelectorComponent {
  constructor(
    private srv: CustomerSelectorService,
    private config: PhConfigLoaderService
  ) {}

  get filteredItems$() {
    return this.srv.filteredItems$;
  }

  get searchValue$() {
    return this.srv.searchValue$;
  }

  selectCustomer(customer) {
    window.location.href = this.config
      .getConfig('ROOT_DOMAIN')
      .replace('[CUSTOMER]', customer.subdomain);
  }
}
